import moment from "moment";

/** Normalize schedule leave API row for reports/payout (replaces tbl_StaffLeave shape). */
export const normalizeRosterLeaveRow = (leave) => {
  if (!leave) return null;
  const srId = leave.sr_ID ?? leave.SR_ID ?? leave.sl_ID ?? leave.SL_ID;
  const rosterDate = leave.rosterDate ?? leave.RosterDate ?? leave.startDate ?? leave.StartDate;
  const dateStr = rosterDate ? moment(rosterDate).format("YYYY-MM-DD") : null;
  const totalHours = Number(leave.totalHours ?? leave.TotalHours ?? 0) || 0;
  const isPaid = !!(leave.isPaidLeave ?? leave.IsPaidLeave ?? leave.isPaid ?? leave.IsPaid);
  const reason = leave.leaveReason ?? leave.LeaveReason ?? leave.reason ?? leave.Reason ?? "";

  return {
    SR_ID: srId,
    SL_ID: srId,
    UserName: leave.userName ?? leave.UserName ?? "",
    RosterDate: dateStr,
    StartDate: dateStr,
    EndDate: dateStr,
    LeaveType: reason?.trim() ? reason.trim() : "Leave",
    TotalHours: totalHours,
    IsPaid: isPaid,
    IsPaidLeave: isPaid,
    Reason: reason,
    Payout_ID: leave.payout_ID ?? leave.Payout_ID ?? leave.payoutId ?? null,
  };
};

export const normalizeRosterLeaveList = (data) => {
  if (!Array.isArray(data)) return [];
  return data.map(normalizeRosterLeaveRow).filter(Boolean);
};
